<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">Nueva resolución</v-toolbar-title>
    </v-toolbar>
    <v-card class="spacing-top" v-if="loading">
      <v-flex offset-xs5 pa-5>
        <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
      </v-flex>
    </v-card>
    <v-card class="spacing-top px-2 custom-font-regular" v-else>
      <v-card-text>
        <div class="title-form mt-2">Visto</div>
        <v-divider class="mt-2 mb-3"></v-divider>
        <div class="mx-2">
          <v-textarea v-model="havingRegardTo" :error-messages="havingRegardToErrors" label="Visto 1" required
                        @input="$v.havingRegardTo.$touch()"></v-textarea>
          <v-textarea v-for="(item, index) in havingRegardToList" :key="'havingRegardTo'+index"
                        v-model="havingRegardToList[index]" :label="`Visto ${index + 2}`"></v-textarea>
          <v-tooltip bottom v-if="havingRegardToList.length" class="mr-1">
            <v-btn color="grey" depressed class="square-button" slot="activator" @click="remove(havingRegardToList)">
              <v-icon color="grey darken-3">remove</v-icon>
            </v-btn>
            <span>Borrar infracción</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn color="grey" depressed class="square-button" slot="activator" @click="add(havingRegardToList)">
              <v-icon color="grey darken-3">add</v-icon>
            </v-btn>
            <span>Agregar infracción</span>
          </v-tooltip>
        </div>
        <div class="title-form mt-5">Considerando</div>
        <v-divider class="mt-2 mb-3"></v-divider>
        <div class="mx-2">
          <v-textarea v-for="(item, index) in whereas" :key="'whereas'+index"
                        v-model="whereas[index]" :label="`Considerando ${index + 1}`"></v-textarea>
          <v-tooltip bottom v-if="whereas.length" class="mr-1">
            <v-btn color="grey" depressed class="square-button" slot="activator" @click="remove(whereas)">
              <v-icon color="grey darken-3">remove</v-icon>
            </v-btn>
            <span>Borrar infracción</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn color="grey" depressed class="square-button" slot="activator" @click="add(whereas)">
              <v-icon color="grey darken-3">add</v-icon>
            </v-btn>
            <span>Agregar infracción</span>
          </v-tooltip>
        </div>
        <div class="title-form mt-5">Resuelve</div>
        <v-divider class="mt-2 mb-3"></v-divider>
        <div class="mx-2">
          <v-textarea v-model="resolves" :error-messages="resolvesErrors" label="Resuelve 1" required
                        @input="$v.resolves.$touch()"></v-textarea>
          <v-textarea v-for="(item, index) in resolvesList" :key="'resolves'+index" v-model="resolvesList[index]"
                        :label="`Resuelve ${index + 2}`"></v-textarea>
          <v-tooltip bottom v-if="resolvesList.length" class="mr-1">
            <v-btn color="grey" depressed class="square-button" slot="activator" @click="remove(resolvesList)">
              <v-icon color="grey darken-3">remove</v-icon>
            </v-btn>
            <span>Borrar hecho</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn color="grey" depressed class="square-button" slot="activator" @click="add(resolvesList)">
              <v-icon color="grey darken-3">add</v-icon>
            </v-btn>
            <span>Agregar hecho</span>
          </v-tooltip>
        </div>
        <div class="title-form mt-5">Archivos adjuntos asociados</div>
        <v-divider class="mt-2 mb-3"></v-divider>
        <div class="mx-2" v-if="uploadedFiles.length">
          <v-data-table :items="uploadedFiles" hide-actions hide-headers no-data-text="No hay datos disponibles">
            <template slot="items" slot-scope="props">
              <td><a :href="props.item.url" target="_blank">{{ props.item.name }}</a></td>
              <td class="text-xs-left">{{ props.item.description }}</td>
            </template>
          </v-data-table>
        </div>
        <div class="mx-2">
          <AttachFile ref="fileInput" @upload="uploadFiles" description></AttachFile>
          <v-checkbox v-if="files.length || uploadedFiles.length" v-model="canViewAttachments" label="Club puede ver adjuntos"></v-checkbox>
          <v-tooltip bottom>
            <v-btn color="grey" depressed class="square-button" slot="activator" @click="openFileDirectory">
              <v-icon color="grey darken-3">add</v-icon>
            </v-btn>
            <span>Agregar adjunto</span>
          </v-tooltip>
        </div>
        <v-divider class="mt-5 mb-2"></v-divider>
        <ConfirmationDialog :function-yes="bindingFunction" ref="confirm" title="Abandonar página"
                            text="Se perderán los cambios del formulario actual, ¿desea continuar?"></ConfirmationDialog>
        <v-card-actions>
          <v-btn color="grey" depressed :disabled="saving" @click="goBackConfirmation">Volver</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="uploadAllFiles" depressed color="primary" :disabled="saving">Enviar</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { createEntityMixin } from '../../../mixins/createEntityMixin'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'

import AttachFile from '../../../common/ui/AttachFile'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'

export default {
  mixins: [validationMixin, createEntityMixin, s3UploadMixin],

  props: {
    prefixCreatePath: {
      type: String,
      default: 'case_file/generate_resolution/'
    }
  },

  validations () {
    return {
      havingRegardTo: { required },
      resolves: { required }
    }
  },

  components: {
    AttachFile,
    ConfirmationDialog
  },

  data () {
    return {
      havingRegardTo: '',
      havingRegardToList: [],
      whereas: [],
      resolves: '',
      resolvesList: [],
      canViewAttachments: false,
      uploadedFiles: [],
      axiosMethod: this.axios.put,
      editPath: `case_file/entry/resolution/edit/${this.$route.params.idResolution}`
    }
  },

  computed: {
    isEditing () {
      return this.$route.params.hasOwnProperty('idResolution')
    },
    havingRegardToErrors () {
      return this.getRequiredErrors('havingRegardTo')
    },
    resolvesErrors () {
      return this.getRequiredErrors('resolves')
    },
    createPath () {
      return this.prefixCreatePath + this.$route.params.id
    }
  },

  methods: {
    add (array) {
      array.push('')
    },
    remove (array) {
      array.pop()
    },
    getPayload () {
      let payload = {
        'having_regard_to': [...[this.havingRegardTo], ...this.havingRegardToList],
        'resolves': [...[this.resolves], ...this.resolvesList],
        'can_view_attachments': this.canViewAttachments,
        'assets': this.assets
      }
      if (this.whereas.length) payload.whereas = this.whereas
      return payload
    },
    setData (data) {
      this.havingRegardTo = data.detail.infringements[0]
      this.havingRegardToList = data.detail.infringements.slice(1)
      this.resolves = data.detail.resolves[0]
      this.resolvesList = data.detail.resolves.slice(1)
      this.whereas = data.detail.acts || []
      this.canViewAttachments = data.detail.canViewAttachments
      this.uploadedFiles = data.detail.assets
    },
    fetchData () {
      this.loading = true
      this.axios
        .get(`case_file/entry/${this.$route.params.idResolution}`)
        .then(response => {
          this.setData(response.data)
          this.loading = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    isValidForm () {
      return !this.$v.$invalid
    }
  }
}
</script>

<style scoped>
.title-form {
  font-size: 1.3em;
}
.spacing-top {
  margin-top: 6em !important;
}
.square-button {
  margin: 0.5em 0 0 0;
  padding: 0 !important;
  width: 2em !important;
  height: 2em;
  min-width: 20px;
}
</style>
